import { render, staticRenderFns } from "./REAIQueryProps.vue?vue&type=template&id=6ec13820"
import script from "./REAIQueryProps.vue?vue&type=script&lang=js"
export * from "./REAIQueryProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports